import { render, staticRenderFns } from "./tabWarehouse.vue?vue&type=template&id=163381f4&scoped=true&"
import script from "./tabWarehouse.vue?vue&type=script&lang=js&"
export * from "./tabWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./tabWarehouse.vue?vue&type=style&index=0&id=163381f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163381f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163381f4')) {
      api.createRecord('163381f4', component.options)
    } else {
      api.reload('163381f4', component.options)
    }
    module.hot.accept("./tabWarehouse.vue?vue&type=template&id=163381f4&scoped=true&", function () {
      api.rerender('163381f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse.vue"
export default component.exports